import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type TemporaryRegistrationBannerProps = {
    handleTemporaryRegistrationDialogOpen: () => void;
};

const TemporaryRegistrationBanner = ({ handleTemporaryRegistrationDialogOpen }: TemporaryRegistrationBannerProps) => (
    <div className="min-h-[78px] bg-blue-cola flex items-center justify-between px-3 py-1">
        <div className="flex items-center gap-2">
            <InfoOutlined color="white" />
            <div className="flex flex-col items-start">
                <Typography fontFamily="Inter" fontSize={16} fontWeight={500} letterSpacing={0.15} color="white.main">
                    <FormattedMessage id="event.temporary.title" defaultMessage="Temporary Registration" />
                </Typography>
                <Typography fontFamily="Roboto" fontSize={14} fontWeight={500} letterSpacing={0.15} color="white.main">
                    <FormattedMessage
                        id="event.temporary.description"
                        defaultMessage="Temporary registrations are available for this event. Click 'Learn More' to view the details."
                    />
                </Typography>
            </div>
        </div>
        <Button
            className="rounded-full font-medium font-roboto text-sm"
            variant="outlined"
            color="white"
            onClick={handleTemporaryRegistrationDialogOpen}
        >
            <FormattedMessage id="common.learnMore" defaultMessage="Learn More" />
        </Button>
    </div>
);

export { TemporaryRegistrationBanner };
